import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useAuth } from './AuthProvider';

export default function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated, shouldBypassAuth } = useAuth();
  const { inProgress } = useMsal();

  const hasAuthResponseHash =
    typeof location?.hash === 'string' &&
    (location.hash.includes('code=') ||
      location.hash.includes('error=') ||
      location.hash.includes('state='));

  // If MSAL is processing a redirect response, do NOT redirect away (it would drop the hash).
  if (!shouldBypassAuth && !isAuthenticated && (inProgress !== 'none' || hasAuthResponseHash)) {
    return null;
  }

  if (shouldBypassAuth || isAuthenticated) {
    return <Outlet />;
  }

  return (
    <Navigate
      to="/login"
      replace
      state={{ from: location }}
    />
  );
}

